<div
  tabindex="0"
  class="collapse bg-base-100 border"
  [class.border-success]="status() === 'Accepted'"
  [class.border-error]="status() !== 'Accepted'"
  [class.collapse-open]="isExpanded()"
  [class.collapse-close]="!isExpanded()">
  <button
    type="button"
    class="collapse-title font-semibold flex justify-between items-center p-3 cursor-pointer"
    (click)="toggleExpand()"
    data-testid="test-case-button">
    <div class="w-[60%] md:w-[40%] flex gap-1">
      <div
        class="border text-xs p-2 rounded-lg"
        [class.bg-emerald-100]="status() === 'Accepted'"
        [class.border-emerald-200]="status() === 'Accepted'"
        [class.text-emerald-700]="status() === 'Accepted'"
        [class.bg-red-100]="status() !== 'Accepted'"
        [class.border-red-200]="status() !== 'Accepted'"
        [class.text-red-700]="status() !== 'Accepted'">
        Test Case {{ index() }}
      </div>
    </div>

    <div class="flex flex-row gap-2.5 items-center">
      <!-- Custom SVG for arrow rotation -->
      <button class="cursor-pointer" (click)="toggleExpand()">
        <svg
          [class.rotate-180]="isExpanded()"
          class="transition-transform duration-300 size-4 cursor-pointer"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          @if (status() === 'Accepted') {
          <path
            d="M13.1 10.5073L8.43334 14.5073C8.39925 14.5298 8.36361 14.5499 8.32667 14.5673L8.24667 14.6207C8.08828 14.6837 7.91173 14.6837 7.75334 14.6207L7.67334 14.5673C7.6364 14.5499 7.60076 14.5298 7.56667 14.5073L2.90001 10.5073C2.62018 10.268 2.58735 9.84714 2.82667 9.56732C3.066 9.28749 3.48685 9.25466 3.76667 9.49398L7.33334 12.554V2.00065C7.33334 1.63246 7.63182 1.33398 8.00001 1.33398C8.3682 1.33398 8.66667 1.63246 8.66667 2.00065V12.554L12.2333 9.49398C12.5132 9.25466 12.934 9.28749 13.1733 9.56732C13.4127 9.84714 13.3798 10.268 13.1 10.5073Z"
            fill="#16A34A" />
          }@else{
          <path
            d="M13.1 10.5073L8.43334 14.5073C8.39925 14.5298 8.36361 14.5499 8.32667 14.5673L8.24667 14.6207C8.08828 14.6837 7.91173 14.6837 7.75334 14.6207L7.67334 14.5673C7.6364 14.5499 7.60076 14.5298 7.56667 14.5073L2.90001 10.5073C2.62018 10.268 2.58735 9.84714 2.82667 9.56732C3.066 9.28749 3.48685 9.25466 3.76667 9.49398L7.33334 12.554V2.00065C7.33334 1.63246 7.63182 1.33398 8.00001 1.33398C8.3682 1.33398 8.66667 1.63246 8.66667 2.00065V12.554L12.2333 9.49398C12.5132 9.25466 12.934 9.28749 13.1733 9.56732C13.4127 9.84714 13.3798 10.268 13.1 10.5073Z"
            fill="#fb2c36" />
          }
        </svg>
      </button>
    </div>
  </button>
  <div class="collapse-content">
    <div class="h-full w-full">
      @if (status() === 'Accepted' || status() === 'Failed' ){
      <!-- Input (stdin) -->
      <div class="flex-col w-full">
        <div class="flex">
          <legend class="fieldset-legend">Input (stdin)</legend>
        </div>
        <input
          name="input-{{ data()?.input }}"
          type="text"
          [value]="inputValue()"
          [readOnly]="true"
          class="w-full input placeholder-gray-300 rounded-lg"
          placeholder='e.g. [1,2], "abc", 123'
          (keydown.enter)="$event.preventDefault()"
          required />
      </div>

      <div class="flex flex-col md:flex-row gap-3">
        <div class="flex-col w-full">
          <div class="flex">
            <legend class="fieldset-legend">Expected Output</legend>
          </div>
          <input
            name="expected-output-{{ data()?.expectedOutput }}"
            type="text"
            [value]="expectedOutput()"
            [readOnly]="true"
            class="w-full input placeholder-gray-300 rounded-lg"
            placeholder='e.g. [1,2], "abc", 123'
            (keydown.enter)="$event.preventDefault()"
            required />
        </div>
        <div class="flex-col w-full">
          <div class="flex">
            <legend class="fieldset-legend">Actual Output</legend>
          </div>
          <input
            name="expected-output-{{ data()?.actualOutput }}"
            type="text"
            [value]="actualOutput()"
            [readOnly]="true"
            class="w-full input placeholder-gray-300 rounded-lg"
            placeholder='e.g. [1,2], "abc", 123'
            (keydown.enter)="$event.preventDefault()"
            required />
        </div>
      </div>

      <div class="flex flex-col md:flex-row gap-3">
        <div class="flex-col w-full">
          <div class="flex">
            <legend class="fieldset-legend">Time Execution</legend>
          </div>
          <label class="input rounded-lg w-full">
            <input
              name="time-limit-{{ data()?.executionTime }}"
              type="number"
              [value]="executionTime()?.toString()"
              [readOnly]="true"
              (keydown.enter)="$event.preventDefault()" />
            <span class="label">milliseconds</span>
          </label>
        </div>
        <div class="flex-col w-full">
          <div class="flex">
            <legend class="fieldset-legend">Memory Execution</legend>
          </div>
          <label class="input rounded-lg w-full">
            <input
              name="memory-limit-{{ data()?.memoryUsed }}"
              type="number"
              [value]="memoryUsed()?.toString()"
              [readOnly]="true"
              (keydown.enter)="$event.preventDefault()" />
            <span class="label">kilobytes</span>
          </label>
        </div>
      </div>
      } @else{
      <div
        class="mt-4 p-4 bg-error-subtle border border-error text-error rounded-xl">
        <div class="flex items-center">
          <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path
              fill-rule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
              clip-rule="evenodd"></path>
          </svg>
          <span class="font-medium">{{ data()?.status }}</span>
        </div>
      </div>
      }
    </div>
  </div>
</div>
